/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useCallback, useEffect, useMemo, useState} from 'react';
import {
    ADD_TAGS_TO_ACCOUNTS,
    DELETE_ACCOUNTS,
    GET_ACCOUNTS,
    GET_ACCOUNTS_EXPORT,
    MERGE_ACCOUNTS,
    REMOVE_TAGS_FROM_ACCOUNTS
} from "../../database/queries/accountQueries";
import {SizeMe} from "react-sizeme";
import {makeStyles} from "@material-ui/core/styles";
import {notify} from "../../utils/notify";
import {useMutation, useQuery} from "@apollo/react-hooks";
import PageBar from "../Common/PageBar";
import {Link, Route, Switch, useHistory, useRouteMatch} from "react-router-dom";
import usePersistentStore from "../../persistentStore";
import {GET_FILTER} from "../../database/queries/filterQueries";
import * as utils from "../../utils/utils";
import {sortedArraysEqual} from "../../utils/utils";
import moment from "moment";
import ExpandedTable from "../Common/ExpandedTable/expandedTable";
import CssBaseline from "@material-ui/core/CssBaseline";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginTop: 20,
    },
}));

const AccountList = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [filter, setFilter] = useState();
    const [exportAccountIds, setExportAccountIds] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [exportFields, setExportFields] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const history = useHistory();
    const [accounts, setAccounts] = useState([]);
    const [accountCount, setAccountCount] = useState(0);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [orderList, setOrderList] = useState();
    const [skipPageReset, setSkipPageReset] = useState(false)
    let {url} = useRouteMatch();

    const columns = useMemo(
        () => [
            {
                id: 'accountName',
                Header: 'Name',
                accessor: r => {
                    return (
                        <Link to={`${url}/${r.accountId}`}
                              onClick={() => globalPersistentActions.setDetailTabsTitle(r.accountName)}>
                            {r.accountName}
                        </Link>
                    );
                },
                sortFields: ['accountName']
            },
            {
                id: 'accountLinkedinId',
                Header: 'Linkedin Id',
                accessor: r => {
                    if (r.accountLinkedinId) {
                        return <a href={'https://linkedin.com/company/' + r.accountLinkedinId}
                                  target={"_blank"} rel="noopener noreferrer">{r.accountLinkedinId}</a>
                    } else {
                        return ""
                    }
                },
                sortFields: ['accountLinkedinId']
            },
            {
                id: 'updatedAt',
                Header: 'Last Updated',
                accessor: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
                sortFields: ['updatedAt']
            },
            {
                id: 'tags',
                Header: 'Tags',
                accessor: r => {
                    return <span>{r.tags.map(tag => tag.tag).join(', ')}</span>
                },
                disableSortBy: true,
            }
        ],
        []
    )

    const {loading: getAccountsLoading, error: getAccountsError, data: getAccountsData, refetch: getAccountsRefetch} =
        useQuery(GET_ACCOUNTS, {
            fetchPolicy: "no-cache",
            variables: {
                searchStr: searchStr,
                filterSQL: filter ? filter.filterSQL : null,
                limit: pageSize,
                offset: pageIndex * pageSize,
                orderList: orderList
            },
        });

    const {refetch: getAccountsExportRefetch} = useQuery(GET_ACCOUNTS_EXPORT, {
        skip: exportAccountIds.length === 0,
        variables: {
            accountIds: exportAccountIds
        }
    });

    const {data: getFilterData, refetch: getFilterRefetch} = useQuery(GET_FILTER, {
        skip: !globalPersistentState.accountFilterId,
        variables: {
            filterId: globalPersistentState.accountFilterId,
        },
    });

    const [deleteAccounts, {error: deleteAccountsError}] = useMutation(DELETE_ACCOUNTS);
    const [mergeAccounts, {error: mergeAccountsError}] = useMutation(MERGE_ACCOUNTS);
    const [addTagsToAccounts] = useMutation(ADD_TAGS_TO_ACCOUNTS);
    const [removeTagsFromAccounts] = useMutation(REMOVE_TAGS_FROM_ACCOUNTS);

    const handleSearch = (s) => {
        setSearchStr(s);
        getAccountsRefetch();
    };

    const handleRefresh = () => {
        console.log('setSkipPageReset false due to refresh');
        setSkipPageReset(false);
        getAccountsRefetch().then((result) => {
            if (!skipPageReset) setSkipPageReset(true);
        });
    };

    const handleDelete = async () => {
        deleteAccounts({
            variables: {deleteAccountIds: selectedIds}
        }).then(async deleteAccountsResult => {
            console.log('setSkipPageReset false due to delete');
            setSkipPageReset(false);
            await getAccountsRefetch();
            return deleteAccountsResult;
        }).then(async deleteAccountsResult => {
            if (deleteAccountsResult.data.deleteAccounts.returnCode === 0) {
                notify('deleteAccounts', 'info', deleteAccountsResult.data.deleteAccounts.message);
            } else {
                notify('deleteAccounts', 'error', deleteAccountsResult.data.deleteAccounts.message);
            }
        }).catch(e => {
            notify('deleteAccounts', 'error', e.message);
            getAccountsRefetch();
        })
    };

    const handleAddTags = async (tagObjList) => {
        console.log('lkjh', selectedIds, tagObjList);
        addTagsToAccounts({
            variables: {accountIdList: selectedIds, tagObjList: tagObjList}
        }).then(async addTagsToAccountsResult => {
            await getAccountsRefetch();
            return addTagsToAccountsResult;
        }).then(async addTagsToAccountsResult => {
            notify('addTagsToAccounts', addTagsToAccountsResult.data.addTagsToAccounts.returnCode === 0 ? 'info' : 'error', addTagsToAccountsResult.data.addTagsToAccounts.message);
        }).catch(e => {
            notify('addTagsToAccounts', 'error', e.message);
            getAccountsRefetch();
        });
    };

    const handleRemoveTags = async (tagObjList) => {
        removeTagsFromAccounts({
            variables: {accountIdList: selectedIds, tagObjList: tagObjList}
        }).then(async removeTagsFromAccountsResult => {
            await getAccountsRefetch();
            return removeTagsFromAccountsResult;
        }).then(async removeTagsFromAccountsResult => {
            notify('removeTagsFromAccounts',
                removeTagsFromAccountsResult.data.removeTagsFromAccounts.returnCode === 0 ? 'info' : 'error',
                removeTagsFromAccountsResult.data.removeTagsFromAccounts.message);
        }).catch(e => {
            getAccountsRefetch();
            notify('removeTagsFromAccounts', 'error', e.message);
        });
    };

    const handleFilterApply = (filterId) => {
        globalPersistentActions.setAccountFilterId(filterId);
        if (!filterId) setFilter();
    };

    const handleImport = () => {
        console.log('import');
    };

    const handleMerge = (mainAccountId) => {
        mergeAccounts({
            variables: {mainAccountId: mainAccountId, mergeAccountIds: selectedIds}
        }).then(mergeAccountsResult => {
            if (mergeAccountsResult.data.mergeAccounts.returnCode === 0) {
                notify('mergeAccounts', 'info', mergeAccountsResult.data.mergeAccounts.message);
                getAccountsRefetch();
                // tableRef.current && tableRef.current.onQueryChange();
            } else {
                notify('mergeAccounts', 'error', mergeAccountsResult.data.mergeAccounts.message);
                getAccountsRefetch();
                // tableRef.current && tableRef.current.onQueryChange();
            }
        }).catch(e => {
            notify('mergeAccounts', 'error', e.message);
            getAccountsRefetch();
            // tableRef.current && tableRef.current.onQueryChange();
        })
    };

    useEffect(() => {
        console.log('getAccountsData', getAccountsData);
        if (getAccountsData) {
            setAccounts(getAccountsData.accounts.rows);
            setAccountCount(getAccountsData.accounts.count);
            globalPersistentActions.setDetailTabsTitle();
        }
    }, [getAccountsData]);

    useEffect(() => {
        if (selectedIds.length > 0) setExportAccountIds(selectedIds);
    }, [exportFields]);

    const handleExport = (fields) => {
        setExportFields(fields);
    };

    useEffect(() => {
        if (exportAccountIds.length > 0) {
            getAccountsExportRefetch().then(async fetchResult => {
                const rows = await utils.convertExportsToCSV(fetchResult.data.accountsExport, exportFields);
                const element = document.createElement("a");
                const file = new Blob([rows],
                    {type: 'text/csv;charset=utf-8'});
                element.href = URL.createObjectURL(file);
                element.download = 'junctionbox-export-' + moment().format() + '.csv';
                document.body.appendChild(element);
                element.click();
            }).catch(e => {
                console.trace(e);
            });
        }
    }, [exportAccountIds]);

    useEffect(() => {
        if (deleteAccountsError) notify('deleteAccountError', 'error', deleteAccountsError.message);
        if (mergeAccountsError) notify('mergeAccountError', 'error', mergeAccountsError.message);
        if (getAccountsError) notify('getAccountsError', 'error', getAccountsError.message);
    }, [deleteAccountsError, getAccountsError, mergeAccountsError]);

    useEffect(() => {
        getAccountsRefetch();
        // tableRef.current && tableRef.current.onQueryChange();
    }, [filter]);

    useEffect(() => {
        if (getFilterData && getFilterData.filter) {
            setFilter(getFilterData.filter);
        }
    }, [getFilterData]);

    useEffect(() => {
        if (globalPersistentState.filterId) getFilterRefetch();
    }, [globalPersistentState.filterId]);

    const getOrderList = (sortBy) => {
        let orderList = [];
        if (sortBy && sortBy.length > 0) {
            for (let s = 0; s < sortBy.length; s++) {
                const sortFld = sortBy[s];
                const sortDir = sortFld.desc ? 'DESC' : 'ASC';
                const sortCol = columns.filter(column => column.id === sortFld.id);
                if (sortCol && sortCol.length > 0) {
                    const sortFields = sortCol[0].sortFields;
                    if (sortFields) {
                        for (let f = 0; f < sortFields.length; f++) {
                            orderList.push(`${sortFields[f]} ${sortDir}`);
                        }
                    }
                }
            }
        }
        console.log('orderList', orderList);
        return orderList;
    }

    const getData = useCallback((pageIndex, pageSize, sortBy) => {
        setOrderList(getOrderList(sortBy));
        setPageSize(pageSize);
        setPageIndex(pageIndex);
        getAccountsRefetch();
    }, []);

    // const accountData = React.useMemo(() => accounts, [accounts])

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <PageBar
                    {...props}
                    title={`Accounts (${selectedIds.length}/${accountCount})`}
                    handleSearch={handleSearch}
                    handleRefresh={handleRefresh}

                    handleAdd={() => {
                        console.log('## SVR accountList ## changing history', `${url}/new`);
                        history.push(`${url}/new`);
                    }}
                    addDisabled={selectedIds.length > 0}

                    mergeType={"account"}
                    mergeChoices={selectedRows}
                    handleMerge={handleMerge}
                    mergeDisabled={selectedIds.length < 2}

                    handleEdit={() => {
                        console.log('## SVR accountList ## changing history', selectedObj, `${url}/${selectedObj.accountId}`);
                        history.push(`${url}/${selectedObj.accountId}`);
                    }}
                    editDisabled={selectedIds.length !== 1}

                    addTagsTitle={"Change Tags for Selected Accounts"}
                    handleAddTags={handleAddTags}
                    handleRemoveTags={handleRemoveTags}
                    tagDisabled={selectedIds.length === 0}

                    filterType="account"
                    filterName={filter ? filter.filterName : null}
                    handleFilterApply={handleFilterApply}

                    handleDelete={handleDelete}
                    deleteDisabled={selectedIds.length === 0}

                    handleImport={handleImport}

                    handleExport={handleExport}
                    exportDisabled={selectedIds.length === 0}

                    showLoading={getAccountsLoading}
                >
                </PageBar>
                <div className={classes.root}>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;

                            return (
                                <div>
                                    <CssBaseline/>
                                    {accounts && (<ExpandedTable
                                        columns={columns}
                                        data={accounts}
                                        dataCount={accountCount}
                                        getData={getData}
                                        pageSize={pageSize}
                                        pageIndex={pageIndex}
                                        skipPageReset={skipPageReset}
                                        setSkipPageReset={setSkipPageReset}
                                        getRowId={row => row.accountId}
                                        testFieldName={"accountName"}
                                        setSelected={(sortedIds, rows) => {
                                            const theSame = sortedArraysEqual(selectedIds, sortedIds);
                                            if (!theSame) {
                                                console.log('setting selected rows', sortedIds);
                                                setSelectedIds(sortedIds)
                                                setSelectedRows(rows);
                                                if (rows && rows.length === 1) {
                                                    setSelectedObj(rows[0])
                                                } else {
                                                    setSelectedObj({})
                                                }
                                            }
                                        }}
                                    />)}
                                </div>
                            );
                        }}
                    </SizeMe>
                </div>
            </Route>}
            <Route path={`${url}/:editId`}>
                {cloneElement(props.parent.routes.edit.component, {
                    ...props,
                    editType: 'account',
                    parentRefresh: () => {
                        // tableRef.current && tableRef.current.onQueryChange();
                        getAccountsRefetch();
                    },
                    parent: props.parent.routes.edit
                })}
            </Route>
        </Switch>
    );
};

export default AccountList;
